import ErrorHandler from './ErrorHandler';

export function fetchDuration(id, amount) {
  return fetch(`/api/products/${id}/duration?amount=${amount}`, { method: 'GET' })
    .then(ErrorHandler)
    .then(response => response.json());
}
